'use client'

import { useQuery } from '@tanstack/react-query'
import Link from 'next/link'
import { Gamepad2 } from 'lucide-react'
import { fetchGamesCatalog } from '@/lib/api/games-routes'
import { Spinner } from '@/components/ui/spinner'

const GAME_LINKS: Record<string, string> = {
  'player-guess': '/games/player-guess',
  'transfer-guess': '/games/transfer-guess',
  'connect-the-players': '/games/connect-the-players',
}

export function GamesPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['gamesCatalog'],
    queryFn: fetchGamesCatalog,
    staleTime: 60 * 60 * 1000,
  })

  // Wages Guess is retired from the frontend — the catalog is server-driven,
  // so filter it out here rather than removing it on the backend.
  const games = (data?.data ?? []).filter((game) => game.slug !== 'wages-guess')

  return (
    <div className="mx-auto w-full max-w-3xl px-0 py-6 sm:px-4">
      <h1 className="px-4 text-lg font-semibold text-white sm:px-0">Games</h1>

      {isLoading ? (
        <div className="flex justify-center py-10">
          <Spinner className="size-6 text-white/50" />
        </div>
      ) : (
        <div className="mt-4 grid grid-cols-1 gap-3 px-4 sm:grid-cols-2 sm:px-0">
          {games.map((game) => (
            <Link
              key={game.id}
              href={GAME_LINKS[game.slug] ?? '/games'}
              className="flex items-center gap-3 rounded-md border border-white/10 p-4 no-underline transition-colors hover:bg-white/5"
              style={{ background: '#0a0c0e' }}
            >
              <div className="flex size-10 shrink-0 items-center justify-center rounded-md border border-white/10 bg-black">
                <Gamepad2 className="size-5 text-white/70" strokeWidth={1.75} />
              </div>
              <div className="min-w-0">
                <p className="text-sm font-medium text-white">{game.name}</p>
                {game.description && (
                  <p className="mt-0.5 truncate text-xs text-white/50">{game.description}</p>
                )}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}
